<template>
  <b-card>
    <b-row>
      <b-col md="7" class="p-0">
        <div class="my-2 mb-4 ml-4 mr-4">
          <h1>Create User</h1>
          <v-stepper alt-labels v-model="e1">
            <v-stepper-header>
              <v-stepper-step
                step="1"
                class="v-stepper-step-outline"
                style="margin-left: 24px"
                >User Information</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="2" class="v-stepper-step-outline"
                >Address Info</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="3" class="v-stepper-step-outline"
                >Access Control</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="4" class="v-stepper-step-outline"
                >KYC verification</v-stepper-step
              >
              <v-divider />

              <v-stepper-step step="5" class="v-stepper-step-outline"
                >Done</v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <s-userinfo class="mt-2">
                  <template v-slot:footer-button="data">
                    <b-button
                      class="btn btn-block mt-3"
                      btn-color="primary"
                      @click="userInfoToNext(data.data)"
                      >Next</b-button
                    >
                  </template>
                </s-userinfo>
              </v-stepper-content>

              <v-stepper-content step="2">
                <s-addressinfo :tenants="tenants" @place_changed="setPlace">
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 1" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AddressToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-addressinfo>
              </v-stepper-content>

              <v-stepper-content step="3">
                <s-acess class="mt-2">
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 2" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AccessToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-acess>
              </v-stepper-content>

              <v-stepper-content step="4">
                <s-kyc
                  class="mt-2"
                  ref="kycForm"
                  @readKYC="KYCUpdate($event)"
                  :documentList="documentList"
                  :userID="currentUser"
                >
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 3" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          :disabled="
                            !kycChangeObj.addressProofBack ||
                            !kycChangeObj.addressProofFront ||
                            !kycChangeObj.photoIdFront ||
                            !kycChangeObj.photoIdBack ||
                            !kycChangeObj.idproofNo ||
                            !kycChangeObj.addressproofNo
                          "
                          @click="AgreeToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-kyc>
              </v-stepper-content>

              <v-stepper-content step="5">
                <s-thanks @done="done"></s-thanks>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </b-col>
      <b-col md="5" col-4="image" class="p-0">
        <img src="img/svg/createUser.svg" class="img-avatar" v-if="e1 != 2" />
        <div v-else>
          <GmapMap
            :center="position"
            :zoom="10"
            map-type-id="terrain"
            style="width: 540px; height: 541px"
          >
            <GmapMarker label="★" :draggable="false" :position="position" />
          </GmapMap>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import AddressStepper from "@/components/User/AddressStepper.vue";
import sUserInfo from "@/components/User/UserInfoStepper.vue";
import AcessStepper from "@/components/User/AccessStepper.vue";
import sThanks from "@/components/User/ThankYouStepper.vue";
import sAgreement from "@/components/Tenant/Agreement.vue";
import sKYC from "@/components/User/KYC_v2.vue";

export default {
  name: "CreateUser",
  components: {
    "s-addressinfo": AddressStepper,
    "s-userinfo": sUserInfo,
    "s-acess": AcessStepper,
    sThanks,
    sAgreement,
    "s-kyc": sKYC,
    cInput,
  },
  data() {
    return {
      currentUser: null,
      e1: 0,
      tenants: [],
      kycChangeObj: {},
      userinfo: null,
      address: null,
      authentication: null,
      agreement: null,
      documentList: null,
      position: {
        lat: 0,
        lng: 0,
      },
    };
  },
  methods: {
    async userInfoToNext(item) {
      this.userinfo = item;
      this.e1 = 2;
    },
    async AddressToNext(item) {
      this.address = item.address;
      this.e1 = 3;
    },
    async AccessToNext(item) {
      this.authentication = item;
      this.e1 = 4;
      const { address, userinfo, authentication } = this;
      let orgaccess = [];
      if (authentication.orgAccessList && authentication.orgAccessList.length > 0) {
        authentication.orgAccessList.map((obj) => {
          orgaccess.push(obj._id);
        });
      }
      let rolesarray = [];
      authentication.role.map((obj) => {
        rolesarray.push(obj._id);
      });
      let payload = {
        name: {
          first: userinfo.first,
          last: userinfo.last,
        },
        experience: {
          value: userinfo.value,
          uom: userinfo.uom,
        },
        profilePhoto: userinfo.profilePhoto,
        dob: userinfo.dob,
        gender: userinfo.gender,
        aboutMe: userinfo.aboutMe,
        maritalStatus: userinfo.maritalStatus,
        education: userinfo.education,
        authentication: {
          email: userinfo.email,
          userName: authentication.userName,
          password: authentication.password,
          phone: userinfo.phone,
        },
        address,
        authorization: {
          geoAccess: {},
          orgAccess: {
            orgAccessLevel: authentication.orgAccessLevel
              ? authentication.orgAccessLevel.value
              : "Global",
            orgAccessList: orgaccess,
          },
          roles: rolesarray,
        },
        category: authentication.category.value,
        tenant: this.userTenantId,
        //  officeHierarchy:this.$currentUserData._id,
      };
      /*  if (this.userRole === "Tenant") {
        payload.officeHierarchy = {
          category: "TENANT",
          _id: this.userId
        };
      }*/
      if (this.userRole === "Partner") {
        payload.officeHierarchy = this.userId;
      }
      this.$store.dispatch("tenant/createTenantSubAdmin", payload).then((result) => {
        console.log(result);
        this.$swal({
          title: "Success",
          text:
            "User details are submitted successfully.Please Go ahead for KYC Verification.",
          type: "success",
        });
        this.e1 = 4;
        this.currentUser = result.response._id;
      });
    },
    AgreeToNext(item) {
      this.$refs.kycForm
        .submitKyc(this.currentUser)
        .then((result) => {
          this.e1 = 5;
        })
        .catch((error) => {});
    },
    done() {
      this.$router.push({ path: "/user" });
    },
    async setPlace(data) {
      let place = await data;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
    },
    async getKYCList() {
      this.currentTenant = "5ec257652872e3197f808af8";
      this.$store
        .dispatch("tenant/fetchKYCListByTenant", this.currentTenant)
        .then((result) => {
          this.documentList = result.response;
        });
    },
    KYCUpdate(event) {
      this.kycChangeObj = event;
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    userTenantId() {
      if (this.userRole === "Tenant") {
        return this.userId;
      } else if (this.userRole === "Partner") {
        return JSON.parse(sessionStorage.getItem("userLogin"))["tenant"];
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  margin-top: 150px !important;
}
</style>
<style>
.v-stepper {
  box-shadow: none;
}

.v-stepper__header {
  box-shadow: none;
}

.v-btn:before {
  opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 0px;
}

.v-stepper-step-outline {
  border: 1px solid #727cf5 !important;
  height: 0px;
  border-radius: 50%;
  width: 0px;
  margin-top: 8px;
  /* margin-right: 0px; */
  /* margin-left: 0; */
  margin-bottom: 40px;
  float: left;
}
@-moz-document url-prefix() {
  .v-stepper-step-outline {
    padding: 24px 4px 24px 4px;
  }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
  color: #ffffff;
  background-color: #727cf5 !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
  margin-right: 0;
  margin-bottom: 22px;
  margin-top: -21px;
}
.v-stepper__step__step {
  min-height: 42px;
  min-width: 42px !important;
}
.v-stepper__content {
  padding: 0px !important;
  margin-top: 25px;
}
/* Deactive Stepper */
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: #8badd6 !important;
}
/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px 0px;
  -ms-flex-item-align: start;
  align-self: flex-start;
}
</style>
